/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "*RouterLinkProps" }] */

import * as React from "react"
import { clsx } from "clsx"
import * as styles from "./styles.css"
import { IconType } from "react-icons"
import { Text } from "../text"
import {
  FiAlertTriangle,
  FiAlertOctagon,
  FiCheckCircle,
  FiInfo,
} from "react-icons/fi"

const Icons = {
  primary: FiInfo,
  critical: FiAlertOctagon,
  caution: FiAlertTriangle,
  positive: FiCheckCircle,
}

export type NotificationProps = {
  children: React.ReactNode
  tone?: `primary` | `critical` | `caution` | `positive`
  icon?: IconType
}

export function Notification({
  children,
  tone = `caution`,
  icon,
}: NotificationProps) {
  const Icon = icon || Icons?.[tone]

  return (
    <div className={clsx(styles.root, styles.tones?.[tone])}>
      {Icon && <Icon className={styles.icon} />}
      <Text tone={tone} size="xs">
        {children}
      </Text>
    </div>
  )
}
